function looksLikeEmail(value) {
  const at = value.indexOf("@");
  if (at < 1 || value.includes("@", at + 1)) return false;
  const domain = value.slice(at + 1);
  for (let i = 0; i < value.length; i++) {
    const code = value.codePointAt(i);
    if (
      code === 32 || code === 9 || code === 10 || code === 13 || code === 12 || code === 11
      || code === 0xa0 || code === 0xfeff || code === 0x1680 || code === 0x2028 || code === 0x2029
      || code === 0x202f || code === 0x205f || code === 0x3000
      || (code >= 0x2000 && code <= 0x200a)
    ) return false;
  }
  for (let i = 1; i < domain.length - 1; i++)
    if (domain[i] === ".") return true;

  return false;
}

export const fieldsRules = {
  required: function(param, fem = false) {
    const output = fem
      ? [
        v => !!v || "Une " + param + " est requise.",
      ]
      : [
        v => !!v || "Un " + param + " est requis.",
      ];

    return output;
  },
  email: [
    v => (!v || v.length < 10 || looksLikeEmail(v)) || "L'e-mail doit être valide.",
  ],
  phone: [
    v => !!v || "Un numéro de téléphone est requis.",
    v => (v && v.length >= 10) || "Le numéro de téléphone doit être supérieur à 10 charactères.",
  ],
  password: function(pass) {
    const output = [
      v => pass === v || "Les mots de passes ne correspondent pas",
    ];

    return output;
  },
  twoEmails: function(email) {
    const output = [
      v => email === v || "Les adresse email ne correspondent pas",
    ];

    return output;
  },
};
